import UI from "../../components/ExcerciseTypes/Design/UserInterface";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";

const json = {
  1: { // Exercise num
    unit: "Unit 9",
    id: "SB3-U9-P65-E1",
    audio: "img/FriendsPlus/Page65/Audio/audio-e1-p65.mp3",
    video: "",
    component: T6,
    stylesTextInput: { borderBottomWidth: 0, backgroundColor: 'transparent' },
    exerciseKey: "img/FriendsPlus/Page65/E1/Key/answerKey.png",
    inputSize: 34,
    maxLength: 1,
    textAlign: 'center',
    titleImage: "",
    titleQuestion: [
      {
        color: "#44509f", num: "1",
        title: 'Listen and number. <headphone name="103" src="img/FriendsPlus/Page65/Audio/tieude-e1-p65.mp3"></headphone>',
      },
    ],
    questionImage: [],
    questions: [
      {
        title: `
          <div style='display: flex; flex-direction: row;position: relative;'>
            <img src="img/FriendsPlus/Page65/E1/1.jpg" style="width: 100%">
            <div style='position: absolute;top: 99px;left: 289px;'>#</div>
            <div style='position: absolute;top: 26px;left: 335px;'>#</div>
            <div style='position: absolute;top: 81px;left: 381px;'>#</div>
            <div style='position: absolute;top: 83px;left: 493px;'>#</div>
            <div style='position: absolute;top: 24px;left: 647px;'>#</div>
          </div>
        `,
        answer: ['5', '3', '2', '6', '4'],
      },
    ],
  },
  2: { // Exercise num
    unit: 'Unit 9',
    id: 'SB3-U9-P65-E2',
    audio: '',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: 'img/FriendsPlus/Page65/E2/1.jpg' }]],
  },
  3: { // Exercise num
    unit: 'Unit 9',
    id: 'SB3-U9-P65-E3',
    audio: '',
    video: '',
    component: UI,
    question: [],
    questionImage: [
      [
        { url: 'img/FriendsPlus/Page65/E3/1.jpg' },
        { url: 'img/FriendsPlus/Page65/E3/2.jpg' },
      ],
    ],
  },
  4: { // Exercise num
    unit: 'Unit 9',
    id: 'SB3-U9-P65-E4',
    audio: '',
    video: '',
    component: UI,
    question: [],
    questionImage: [
      [
        { url: 'img/FriendsPlus/Page65/E4/1.jpg' },
        { url: 'img/FriendsPlus/Page65/E4/2.jpg' },
      ],
    ],
  },
}

export default json;